import React from 'react'

export const Home = () => {
  return (
    <div className='max-w-2xl mx-auto px-4 py-8'>
      <p className='text-lg'>Hi, I'm Christian Buco, aspiring Software Engineer. I'm pursuing my Bachelor's degree in Computer Science at California State University, Sacramento, with an expected graduation in 2025.</p>
    </div>
  )
}